import { compose } from 'recompose';
import * as React from 'react';
import Divider from 'material-ui/Divider';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import 'node_modules/video-react/dist/video-react.css';

import * as T from '@modules/delicts/_delictsTypes';

interface GroupedFines {
  totalSum: number;
  [key: string]: number;
}

// ! keep sync with _tickersTypes.d.ts
export enum TicketState {
  ISSUED = 'vydaný',
  USED_CASH = 'použitý - hotovost',
  USED_TERMINAL = 'použitý - terminal',
  USED_BNP = 'použitý BNP',
  DEMAND_BNP = 'předáno BNP k vymáhaní',
  COLLECTED = 'zaplaceno BNP',
  HANDED_OVER_CASH = 'odevzdaná hotovost',
  CANCELED = 'zrušený'
}

const enhance = compose<T.DelictsFormProps, T.Outter & T.DelictsFormProps>();

const View: React.SFC<
  T.Outter &
    T.DelictsFormProps & {
      items: T.Delict[];
      checkedItems: T.Delict[];
    }
> = ({ closeItem, items, checkedItems }) => {
  const itemsToCount = checkedItems.length > 0 ? checkedItems : items;

  const groupedSum: GroupedFines = itemsToCount.reduce(
    (acc, delict) => {
      if (!delict.fine || !delict.fine.value || !delict.fine.state) {
        return acc;
      }

      const fineValue = delict.fine.value;
      const fineState = delict.fine.state;

      if (fineValue && fineState) {
        acc.totalSum += fineValue;

        if (acc[fineState]) {
          acc[fineState] += fineValue;
        } else {
          acc[fineState] = fineValue;
        }
      }
      return acc;
    },
    { totalSum: 0 } as GroupedFines
  );

  return (
    <div className="layout">
      <div style={{ padding: '16px' }}>
        <p>
          <b>Součet zvolených pokut: {groupedSum.totalSum}</b>
        </p>

        <Divider />

        {Object.keys(groupedSum)
          .filter(key => key !== 'totalSum')
          .map(key => (
            <p key={key}>
              <b>{TicketState[key]}: </b>
              {groupedSum[key]}
            </p>
          ))}
      </div>

      <Button label="Zavřít" onClick={closeItem} style={{ margin: '16px 0 16px 16px' }} />
    </div>
  );
};

export const DelictsFineValuesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/delicts/DelictsFineValuesForm.tsx